<template>
  <div class="success">
    <svg
      width="94"
      height="94"
      viewBox="0 0 94 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="success__box"
    >
      <path
        d="M47.0001 0.000191678C72.9573 0.000191678 93.9999 21.0428 93.9999 47.0001C93.9999 72.9573 72.9573 93.9999 47.0001 93.9999C21.0428 93.9999 0.00019495 72.9573 0.00019495 47.0001C-0.0736648 21.1164 20.8491 0.0740514 46.7325 0.000191678C46.8217 -6.38925e-05 46.9109 -6.38925e-05 47.0001 0.000191678Z"
        fill="#3BB54A"
        class="success__box-circle"
      />
      <path
        id="a"
        d="M73.0346 34.048L39.6541 67.4286L20.9609 48.869L28.5718 41.3918L39.6541 52.3407L65.424 26.5708L73.0346 34.048Z"
        fill="#D4E1F4"
        class="success__box-tick"
      />
    </svg>
    <h4>We will contact you soon.</h4>
  </div>
</template>
<style lang="scss" scoped>
.success {
  @extend %flex-center;
  flex-direction: column;
  @include mq(landscape) {
    width: 100%;
  }
  h4 {
    margin-top: 1rem;
    font-weight: 500;
    color: white;
    @include mq(landscape) {
      font-size: 1.1rem;
    }
  }
}
.success__box-circle {
  animation: bounce 2s ease-in-out infinite;
}
.success__box-tick {
  animation: bounceOut 2s ease-in-out infinite;
}

@keyframes bounce {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes bounceOut {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}
</style>
